<template>
  <v-container>
    <RecipeProductConfigurationNotification
      v-if="getIsAdmin === true"
    ></RecipeProductConfigurationNotification>
    <ProductConfigurationAlert></ProductConfigurationAlert>
    <v-row class="mb-2" no-gutters justify="space-between">
      <v-btn
        v-if="getIsAdmin"
        text
        color="success"
        :to="{ name: 'ProductCreator' }"
      >
        <v-icon small left>fa-plus</v-icon>
        Nouveau Produit
      </v-btn>
      <v-btn elevation="0" v-if="getIsAdmin" :to="{ name: 'ProductBulkEditor' }"
        ><v-icon small left>fa-edit</v-icon>Éditeur avancé</v-btn
      >
    </v-row>
    <v-card>
      <v-card-text>
        <RecipeTagsEditor
          v-model="getProductTagsSearchModel"
          solo-inverted
        ></RecipeTagsEditor>
        <RecipeProductGrid
          :items="getFilteredRecipes"
          :loading="getProductLoading"
        ></RecipeProductGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {
  RecipeProductGrid,
  RecipeTagsEditor,
  RecipeProductConfigurationNotification
} from "../components";
import ProductConfigurationAlert from "../components/ProductConfigurationAlert.vue";
import { userInfosMixin } from "@/mixins/userInfosMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [userInfosMixin],
  name: "RecipeProductIndex",
  components: {
    RecipeProductGrid,
    RecipeTagsEditor,
    RecipeProductConfigurationNotification,
    ProductConfigurationAlert
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getOrganisationId",
      "getIntermediateRecipe",
      "getIsAdmin",
      "getStoreId",
      "getProductTagsSearch",
      "getProductLoading"
    ]),
    getProductTagsSearchModel: {
      get() {
        return this.getProductTagsSearch;
      },
      set(v) {
        this.$store.commit("setProductTagsSearch", v);
      }
    },
    getFilteredRecipes() {
      const items = this.getProducts.filter(x => x.est_intermediaire === false);
      if (this.getProductTagsSearch.length > 0) {
        return items.filter(
          x =>
            x.data &&
            this.getProductTagsSearch.every(t => x.data.tags.includes(t))
        );
      } else {
        return items;
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.$store.dispatch("loadTagCategories");
        await this.$store.dispatch("loadAllRecipeStore", {
          organisation: this.getOrganisationId,
          store: this.getStoreId
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped></style>
